module.exports = __webpack_public_path__ + "static/media/zocalo4.48d790bc.jpg";